import React from 'react';

import type { Communication } from '~/components/communications/types';
import CategoryEditableChipBase from '~/components/core/Molecules/CategoryEditableChipBase';
import useOrganization from '~/components/OrganizationContext';
import type { Category } from '~/server_shared/swagger/data-contracts';

interface CommunicationCategoryChipProps {
  communication: Communication;
  disabled?: boolean;
  setIsUpdating: (isUpdating: boolean) => void;
  onUpdate: (communicationId: number, updates: Partial<Communication>) => void | Promise<void>;
  className?: string;
}

const CommunicationCategoryChip: React.FC<CommunicationCategoryChipProps> = ({
  communication,
  disabled,
  setIsUpdating,
  onUpdate,
  className,
}) => {
  const { communicationCategories, isLoadingCommunicationCategories, isErrorCommunicationCategories } =
    useOrganization() as {
      communicationCategories: Category[];
      isLoadingCommunicationCategories: boolean;
      isErrorCommunicationCategories: boolean;
    };

  return (
    <CategoryEditableChipBase
      entity={communication}
      categories={communicationCategories}
      isLoading={isLoadingCommunicationCategories}
      isError={isErrorCommunicationCategories}
      apiEndpoint={`/api/v1/communications/${communication.id}/categories`}
      disabled={disabled}
      setIsUpdating={setIsUpdating}
      onUpdate={onUpdate}
      className={className}
      stopPropagation
    />
  );
};

export default CommunicationCategoryChip;
